import { useCallback, useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'

/**
 * Banner shown at the top of the app when impersonating another user.
 * Only renders in dev mode — fetches status from the /__dev/impersonate endpoint.
 */
export function ImpersonationBanner() {
  const [sub, setSub] = useState<string | null>(null)

  useEffect(() => {
    fetch('/__dev/impersonate')
      .then((r) => r.json())
      .then((data: { impersonating: string | null }) => setSub(data.impersonating))
      .catch(() => {
        /* not in dev mode */
      })
  }, [])

  const stop = useCallback(() => {
    fetch('/__dev/impersonate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sub: null }),
    }).then(() => window.location.reload())
  }, [])

  if (!sub) return null

  return (
    <div className="flex items-center justify-center gap-3 bg-yellow-500 px-3 py-1 text-xs font-medium text-black">
      <span>Impersonating: {sub}</span>
      <Button
        size="sm"
        variant="outline"
        className="h-5 border-black/30 bg-transparent px-2 text-xs text-black hover:bg-black/10"
        onClick={stop}
      >
        Stop
      </Button>
    </div>
  )
}
